// "Outbound Caller · Rexpt Add-on" — Pounce logo ki jagah har screen pe yahi
// pehchaan dikhti hai (icon + naam + chhoti line).
//
// `variant`: "header" = saada, page ke header me; "card" = safed plate ke
// saath, gehre dashboard card pe. Sirf <span> use kiye hain taaki ye HeaderBar
// ke <h6> subtitle ke andar bhi sahi HTML rahe.
//
// Call wala icon sirf "card" variant me — page headers me sirf naam dikhta hai.
import React from "react";
import styles from "./OutboundCallerBrand.module.css";

const OutboundCallerBrand = ({ variant = "header" }) => (
  <span className={`${styles.brand} ${variant === "card" ? styles.card : ""}`}>
    {variant === "card" && <img className={styles.icon} src="/svg/outbound_caller_icon.svg" alt="" />}
    <span className={styles.text}>
      <span className={styles.title}>Outbound Caller</span>
      <span className={styles.subtitle}>Rexpt Add-on</span>
    </span>
  </span>
);

export default OutboundCallerBrand;
